import './App.css'
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import LoginPage from './pages/loginPage'
import HomePage from './pages/homePage'
import Page404 from './pages/Page404'
import { M_Router } from './components/M_Components'

export const QueryEntities = ["Address", "Carrier", "EquipmentType", "Costs", "Customer", "CustomerAddress", "DistanceEstimatedTime","Driver", "company", "Ports", "NavCompanies", "Trailer", "Transport", "Vessel",
        "AccessCard", "Accessory", "FuelCard", "ExtraFuelTax", "FuelTax", "Insurance", "Qualification", "ServiceState", "Toll", "TrailerAccessory", "TrailerType", "ServiceOrderDemandBoardView",
        "ServiceOrderExecutionBoardView", "AvailableDriverBoardView", "AvailableTrailerBoardView", "AvailableTransportBoardView", "AvailableTrinomialBoardView", "LinkableServiceOrderView", "ServiceOrderStateReason",
         "Generator", "ServiceOrderTrinomialCompatibilityView", "ServiceOrderTransportCompatibilityView", "ServiceOrderTrailerCompatibilityView", "ServiceOrderDriverCompatibilityView", "PricePlanAssign"]

export default function App() {

  return (
    <M_Router
      primaryColor={"var(--color-red-dark)"}
      secondaryColor={"var(--color-red)"}
      tertiaryColor={"var(--color-red-light)"}
      endpoints={QueryEntities}
      Routing={
        <Router>
          <Routes>
            {localStorage.getItem("tokenMaeil") ? <Route path="/" element={<Navigate to="/home" />} /> : <Route path="/" element={<Navigate to="/login" />} />}
            <Route path="*" element={<Page404 />} />
            <Route path="/home/*" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
          </Routes>
        </Router>}
    />
  )
}